type Listener = () => void;

const listeners = new Set<Listener>();

export const onCacheUpdate = (listener: Listener): (() => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

export const notifyCacheUpdate = (): void => {
  listeners.forEach((l) => l());
};
